module.exports = __webpack_public_path__ + "static/media/1023542.7e6eb247.png";